import React, { FC } from 'react'
import { useParams } from 'react-router-dom'
import { Header } from '../../../components/common/Header'
import { ModalRecoveryKey } from '../../../components/user/ModalRecoveryKey'
import { PatientProfile } from '../../../components/patients/PatientProfile'

export const PatientProfilePage: FC = () => {
  const { patientId } = useParams()

  return (
    <div className="Dashboard">
      <Header />
      <PatientProfile patientId={patientId} />
      <ModalRecoveryKey />
    </div>
  )
}
